import React, { useEffect, useRef, useState } from 'react';

const easeOutQuad = (t: number) => t * (2 - t);

const Counter = ({ start = 0, end = 0, duration = 2000, easing = easeOutQuad }) => {
  const [count, setCount] = useState(start);

  // Holds the previous "end" value after each animation completes.
  const prevEndRef = useRef(start);

  // Animation bookkeeping

  // tslint:disable-next-line:no-null-keyword
  const startTimeRef = useRef(null);
  // tslint:disable-next-line:no-null-keyword
  const rafRef = useRef(null);

  useEffect(() => {
    // Cancel any in-flight animation
    if (rafRef.current) { cancelAnimationFrame(rafRef.current); }

    const from = prevEndRef.current ?? 0;
    const to = end ?? 0;

    // If nothing to animate, just set and record
    if (from === to || duration <= 0) {
      setCount(to);
      prevEndRef.current = to;

      return;
    }

    startTimeRef.current = undefined;

    const step = (timestamp: number) => {
      if (!startTimeRef.current) { startTimeRef.current = timestamp; }
      const elapsed = timestamp - startTimeRef.current;
      const ratio = Math.min(elapsed / duration, 1);

      const eased = easing(ratio);
      const current = Math.round(from + (to - from) * eased);

      setCount(current);

      if (ratio < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        // Ensure final value & store as previous for next animation
        setCount(to);
        prevEndRef.current = to;
      }
    };

    rafRef.current = requestAnimationFrame(step);

    return () => {
      if (rafRef.current) { cancelAnimationFrame(rafRef.current); }
    };
  }, [end, duration, easing]);

  return <>{count}</>;
};

export default Counter;
